import { Cascader } from 'antd';
import { useEffect, useState } from 'react';
import options from '@/components/AddressSelector/address_options';
const CascaderForm = (props) => {
    let [casOptions, setOptions] = useState([]),
     { setting, updated, desc } = props;
    const disabled = updated !== 0;
    let multiple = setting.type !== 'single';
    //当前写死
    useEffect(() => {
        // let {data_source} = setting //todo请求再赋值
        setOptions(options);
    }, []);
    return <Cascader disabled={disabled} multiple={multiple} options={casOptions} placeholder={desc}></Cascader>;
};
export default CascaderForm;
